import { REPORT_FCI_ACTION } from './ReportFCIConstants';

export default (state = {}, { type, payload }) => {
    switch (type) {
        case REPORT_FCI_ACTION:
            return payload;
        default:
            return state;
    }
};
